import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

import { BaseComponent } from '../../../shared/abstracts/base.abstract';
import { EntityTypeEnum } from '../../../shared/enums/entity-type.enum';
import { IClass } from '../../../shared/interfaces/groups/class.interface';
import { IGroup } from '../../../shared/interfaces/groups/group.interface';
import { IUser } from '../../../shared/interfaces/users/user.interface';

@Component({
    selector: 'app-logged-in-profile',
    templateUrl: './logged-in-profile.component.html',
    styleUrls: ['./logged-in-profile.component.scss'],
})
export class LoggedInProfileComponent extends BaseComponent implements OnInit, OnChanges {
    // @Select(UsersState.getAllUsers) public users$: Observable<IUser[]>;

    @Input() public type: EntityTypeEnum;
    @Input() public contact: IUser | IGroup | IClass;

    @Output()
    public clicked = new EventEmitter<void>();

    public user: IUser;
    public types = EntityTypeEnum;

    // public users: IUser[];

    constructor(private router: Router, private localize: LocalizeRouterService) {
        super();
    }

    ngOnInit(): void {
        // this.uns = this.users$.subscribe((result: IUser[]) => {
        //     this.users = result;
        // });
        this.updateContact(this.contact);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.contact) {
            // removed changes.type &&
            this.updateContact(changes.contact.currentValue);
        }
    }

    public goToRoute(route: string, param: any): void {
        this.clicked.emit();
        this.router.navigate([this.localize.translateRoute(route)], { queryParams: param });
    }

    private updateContact(contact: any): void {
        this.reinitContact();
        this.user = contact;
    }

    private reinitContact(): void {
        this.user = null;
    }
}
